import { Badge, Box, Stack, Text, VStack } from '@chakra-ui/react';

import Card from '@/components/ui/Card/Card';

import { SurveyField } from '../types';
import { getSurveyFieldTypeLabel } from '../utils';

type SurveyFieldPreviewListProps = {
  fields: SurveyField[];
};
export const SurveyFieldPreviewList = ({ fields }: SurveyFieldPreviewListProps) => {
  if (fields.length === 0) {
    return (
      <Card>
        <Stack spacing={2} py={6} textAlign="center" color="gray.800">
          <Text fontWeight="semibold">Brak pól w ankiecie</Text>
          <Text fontSize="sm" color="gray.600">
            Ta ankieta nie zawiera żadnych pytań ani elementów.
          </Text>
        </Stack>
      </Card>
    );
  }

  return (
    <Stack spacing={3}>
      {fields.map((field) => (
        <Card key={field.id}>
          <Stack spacing={3} color="gray.800">
            <VStack align="start" spacing={1}>
              <Stack direction="row" spacing={2} align="center">
                <Text fontWeight="semibold">{field.label}</Text>
                <Badge colorScheme="purple" variant="subtle">
                  {getSurveyFieldTypeLabel(field.type)}
                </Badge>
                {field.isRequired ? (
                  <Badge colorScheme="red" variant="outline">
                    Wymagane
                  </Badge>
                ) : null}
              </Stack>
              {field.type === 'scale' && field.maxRate ? (
                <Text fontSize="sm" color="gray.600">
                  Skala ocen od 1 do {field.maxRate}
                </Text>
              ) : null}
              {field.type === 'divider' ? (
                <Text fontSize="sm" color="gray.600">
                  Separator — element wizualny
                </Text>
              ) : null}
            </VStack>

            {field.type === 'radio' || field.type === 'checkbox' ? (
              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Opcje odpowiedzi:
                </Text>
                <Stack spacing={1}>
                  {field.options?.map((option) => (
                    <Text key={option.id} fontSize="sm" color="gray.700">
                      • {option.label}
                    </Text>
                  ))}
                </Stack>
              </Box>
            ) : null}
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};
